import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "form__fieldset" }
const _hoisted_2 = {
  key: 0,
  class: "form__legend"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Fieldset',
  props: {
    title: {}
  },
  setup(__props: any) {

// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})